import { Box, Typography } from "@mui/material";
import React, { FC } from "react";
import { useIntl } from "react-intl";
import I18nKey from "translations/I18nKey";
import ExclamationBlueIcon from "assets/Icons/ExclamationBlueIcon.svg";
import SellerFilter from "components/SellerFilter";
import SellersList from "./components/SellersList";

const SalesViewAndReportsHeader = () => {
  const intl = useIntl();

  return (
    <Box
      sx={{
        marginTop: "20px",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            color: "#424242",
            fontFamily: "Lato",
          }}
        >
          {intl.formatMessage({
            id: I18nKey.WIDGET_CATEGORY_REPORTS,
          })}{" "}
          :
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 600,
            color: "#424242",
            fontFamily: "Lato",
          }}
        >
          {intl.formatMessage({
            id: I18nKey.SALES_VIEW_AND_REPORTS,
          })}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", marginTop: "15px" }}>
        <Box sx={{ display: "flex", alignItems: "end" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Box sx={{ display: "flex" }}>
                <SellerFilter disableFilter />
                <Box
                  sx={{
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #D0D5DD",
                    cursor: "pointer",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    background: "white",
                  }}
                >
                  <img src={ExclamationBlueIcon} alt={"exclamation blue"} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box>
          <SellersList />
        </Box>
      </Box>
    </Box>
  );
};

export default SalesViewAndReportsHeader;
